import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';

import './StickerMixed.css'

export default (props) => (
  <div>
    <Card>
      <CardTitle title="Letzter Zugriff" />
      <CardText>
        Mixed
      </CardText>
    </Card>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/stickers/StickerMixed.jsx